<div class="my-panel-container">
    <!-- Header -->
    <div class="panel-header">
        <div class="d-flex justify-content-between align-items-center">
            <div>
                <h4 class="mb-1">
                    <i class="ti ti-layout-kanban me-2"></i>
                    Meu Painel
                </h4>
                <p class="text-muted mb-0">
                    Gerencie suas tarefas atribuídas
                    @if (totalTasks() > 0) {
                        <span class="badge bg-primary-subtle text-primary ms-2">
                            {{ totalTasks() }} {{ totalTasks() === 1 ? 'tarefa' : 'tarefas' }}
                        </span>
                    }
                </p>
            </div>
        </div>
    </div>

    <!-- Kanban Board Component -->
    <app-kanban-board
        [config]="kanbanConfig"
        (tasksLoaded)="onTasksLoaded($event)">
    </app-kanban-board>
</div>
